import { FaqDetailPreview } from "types/faqs/types";
import { Langs } from "types/cf-utils/types";
import { getExtraPagesReference } from "helpers/pages";
// import { logDebug } from "helpers/generic";

interface GetFaqBySlug {
  nodeLocale: Langs;
  arraySlug: string[];
  allFaqs: FaqDetailPreview[];
}

export function getFaqBySlug({
  nodeLocale,
  arraySlug = [],
  allFaqs,
}: GetFaqBySlug) {
  // FILTER LANG
  const currentPagesFaqs = allFaqs.filter((page) => {
    if (
      page.node_locale === nodeLocale &&
      arraySlug?.includes(page.slug) &&
      page.activeOnChannel?.includes(process.env.GATSBY_PROJECT_SLUG)
    ) {
      return page;
    }
    return false;
  });

  const currentPages = getExtraPagesReference(currentPagesFaqs) || [];

  // logDebug("current page Faq 2", currentPages);

  return currentPages;
}
